import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DswButtonModule } from '@vi-succ/design-system-web';
import { PickupWarehouseDetailComponent } from '@vi-succ/pickup-warehouse-detail';

@Component({
  selector: 'et-pickup-warehouse-availability',
  templateUrl: './pickup-warehouse-availability.component.html',
  styleUrls: ['./pickup-warehouse-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PickupWarehouseDetailComponent,
    MatIcon,
    TranslateModule,
    MatButtonModule,
    MatRippleModule,
    DswButtonModule,
  ],
})
export class PickupWarehouseAvailabilityComponent {
  @ViewChild(PickupWarehouseDetailComponent)
  pickupWarehouseDetailComponent!: PickupWarehouseDetailComponent;

  constructor(private dialogRef: MatDialogRef<PickupWarehouseAvailabilityComponent>) {}

  onClose() {
    this.dialogRef.close();
  }
}
